export default __webpack_public_path__ + "static/media/paperfive.f6a7668c.jpg";